import "../style.css";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { AudioContext } from './utils/AudioContext'; 
import { useLanguage } from "./utils/LanguageContext";



export default function NavBar() {
    const { isPlaying, stopSounds, playSounds } = useContext(AudioContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const { language, changeLanguage } = useLanguage();

    const toggleSound = () => {
        if (isPlaying) {
            stopSounds();
        } else {
            playSounds();
        }
    };

    const handleLanguageToggle = () => {
        const newLanguage = language === "EN" ? "FR" : "EN";
        changeLanguage(newLanguage);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <nav className="w-full p-6 md:p-10 flex justify-between items-strech z-10 absolute top-0 left-0 opacity-0 animate-[display_1s_cubic-bezier(0.77,0,0.175,1)_0.4s_forwards]">
            <Link to="/" className="px-4 py-3 flex items-center hover:bg-first_alt text-lg text-second flex bg-first transition-all ease-in-out duration-300 font-['sm-avenir'] shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px]">
            {isMobile ? (
                <svg width="20" height="17" viewBox="0 0 20 17" className="fill-second_alt" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z"></path>
                </svg>
                ) :  
                (<h1 className="">{language === "EN" ? "The Fresco" : "La Fresque" }</h1>)
            }
            </Link>
            <div className="flex gap-4 justify-between items-strech">
                <div className="bg-first py-3 px-4 flex shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] items-center gap-2 hover:bg-first_alt cursor-pointer hover:scale-98 transition-all duration-300 ease-in-out" onClick={toggleSound}>
                {isMobile ? "" :  <p className="font-['sm-avenir'] text-lg text-second">{language === "EN" ? "Sound" : "Son" }</p>}
                    {isPlaying ? (
                        <svg width="16" height="16" viewBox="0 0 18 18" className="fill-second" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 5.99998V12H4L9 17V0.99998L4 5.99998H0ZM13.5 8.99998C13.5 7.22998 12.48 5.70998 11 4.96998V13.02C12.48 12.29 13.5 10.77 13.5 8.99998ZM11 0.22998V2.28998C13.89 3.14998 16 5.82998 16 8.99998C16 12.17 13.89 14.85 11 15.71V17.77C15.01 16.86 18 13.28 18 8.99998C18 4.71998 15.01 1.13998 11 0.22998Z"/>
                        </svg>
                    ) : (
                        <svg width="16" height="16" viewBox="0 0 18 18" className="fill-second" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 9C13.5 7.23 12.48 5.71 11 4.97V7.18L13.45 9.63C13.48 9.43 13.5 9.22 13.5 9ZM16 9C16 9.94 15.8 10.82 15.46 11.64L16.97 13.15C17.63 11.91 18 10.5 18 9C18 4.72 15.01 1.14 11 0.23V2.29C13.89 3.15 16 5.83 16 9ZM1.27 0L0 1.27L4.73 6H0V12H4L9 17V10.27L13.25 14.52C12.58 15.04 11.83 15.45 11 15.7V17.76C12.38 17.45 13.63 16.81 14.69 15.95L16.73 18L18 16.73L9 7.73L1.27 0ZM9 1L6.91 3.09L9 5.18V1Z"/>
                        </svg>
                    )}
                </div>
                <div className="flex items-center gap-2 cursor-pointer">
                    <button
                        onClick={handleLanguageToggle}
                        className="bg-first h-full py-3 px-4 flex shadow-[rgba(100,100,111,0.2)_0px_7px_29px_0px] items-center gap-2 hover:bg-first_alt cursor-pointer hover:scale-98 transition-all duration-300 ease-in-out font-['sm-avenir'] text-base md:text-lg text-second"
                    >
                        {language === "EN" ? "FR" : "EN"}
                    </button>
                </div>
            </div>
        </nav>
    );
}
